// @flow

export const changeLanguage = async (_state, dispatch, language) => {
	await dispatch.setLanguage(language);
};
